module.exports = __webpack_public_path__ + "static/img/bannerNew.19544fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Virus/Adenovirus/bannerNew.png
// module id = hY30
// module chunks = 16